import { useEffect, useState } from 'react';
import { callDeepLink, Toast } from '@croquiscom/web2app';
import { toast } from '@croquiscom-pvt/zds';

import { useOnceReveal } from '@common/hooks';
import { LoadingManager } from '@common/overlay-manager';
import { gotoLogin } from '@common/utils';
import { useCatalogProductIdParams, useIsAuthenticated, usePdpConfig } from '@domains/pdp-common';

import { requestAiImageEdit } from '../../../graphql/request-ai-edit.2';
import { useSizeInfoUBL } from '../../../log/useSizeInfoUBL';
import { usePdpShopId } from '../../../queries/usePdpShopId';
import { useSizeInfo } from '../../../queries/useSizeInfoQuery';

export const useLegacyAiCropSizeService = () => {
  const param = useCatalogProductIdParams();
  const sizeInfoUBL = useSizeInfoUBL();
  const { isZigzagApp } = usePdpConfig();
  const { isLoggedIn } = useIsAuthenticated();
  const { targetRef: aiImageRef, isRevealed: isAiImageRevealeds } = useOnceReveal();
  const { targetRef: requestEditButtonRef, isRevealed: isRequestEditButtonRevealed } = useOnceReveal();
  const { data } = useSizeInfo(param);
  const { fetchShopId } = usePdpShopId();

  const [hideAiCropSizeInfo, setHideAiCropSizeInfo] = useState(false); // 수정 요청 후 사이즈 정보 숨김 처리 여부
  const [isEditRequested, setIsEditRequested] = useState(data?.item_list?.[0]?.is_edit_request_clicked || false);

  const aiCropSizeImageList = data?.item_list?.map((item) => item.image_url ?? '').filter(Boolean) ?? [];

  const handleZoom = () => {
    sizeInfoUBL.imageZoomClickUBL(param.catalog_product_id);

    if (isZigzagApp) {
      callDeepLink('/simple_browser')({
        url: encodeURIComponent(`${window.location.origin}/products/${param.catalog_product_id}/size-info/zoom`),
        title: '크게 보기',
      });
    } else {
      window.open(`${window.location.origin}/products/${param.catalog_product_id}/size-info/zoom`, '_blank');
    }
  };

  const handleEditRequest = async () => {
    sizeInfoUBL.editRequestClickUBL(param.catalog_product_id);

    if (isEditRequested) {
      return;
    }

    if (!isLoggedIn) {
      if (isZigzagApp) {
        callDeepLink('/login')();
        return false;
      }

      gotoLogin({ redirect_url: window.location.href });
      return;
    }

    const shopId = await fetchShopId(param.catalog_product_id);

    if (!shopId) {
      return;
    }

    LoadingManager.open({ isMiniLoader: true });

    await requestAiImageEdit({
      catalog_product_id: param.catalog_product_id,
      shop_id: shopId,
    })
      .then(({ data: responseData }) => {
        if (responseData.ux_request_ai_image_edit.is_size_hidden) {
          setHideAiCropSizeInfo(true);
        }
        setIsEditRequested(true);

        if (isZigzagApp) {
          Toast.show('수정 요청이 완료되었어요');
        } else {
          toast({ content: '수정 요청이 완료되었어요' });
        }
      })
      .finally(() => {
        LoadingManager.close();
      });
  };

  useEffect(() => {
    if (isRequestEditButtonRevealed) {
      sizeInfoUBL.editRequestImpressionUBL(param.catalog_product_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRequestEditButtonRevealed]);
  useEffect(() => {
    if (isAiImageRevealeds) {
      sizeInfoUBL.aiSizeImageImpressionUBL(param.catalog_product_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAiImageRevealeds]);

  return {
    hideAiCropSizeInfo,
    aiCropSizeImageList,
    isEditRequested,

    handleZoom,
    handleEditRequest,

    aiImageRef,
    requestEditButtonRef,
  };
};
